import React, { Fragment } from 'react'
import { Container, Image } from 'react-bootstrap'
import { IAdvertiseData } from '../../interfaces/post'

interface IImageAdvertiseHorizontal {
    data?: IAdvertiseData,
    containerClass?: string
}
export default function ImageAdvertiseHorizontal(props: IImageAdvertiseHorizontal) {
    return (
        <Fragment>
            {/* <!-- banner section --> */}
            {props?.data?.mobile_image ?
                <div className={"desktop-banner-section " + (props?.containerClass ? props?.containerClass : "")}>
                    <Container className="theme-light-white">
                        <Image src={props?.data?.mobile_image} className="d-block mx-auto" alt="banner" fluid />
                    </Container>
                </div>
                : null}
            {/* <!-- banner section --> */}
        </Fragment>
    )
}
